import { auth } from '@/shared/lib';
import classNames from 'classnames';
import { BiodirectInfoDrawerContent as DrawerContent } from '@/pages/studies-list/@x/study-management';
import type { BiodirectStatusTabProps } from './biodirectStatusTab.types';
import './biodirectStatusTab.scss';

const BiodirectStatusTab = ({
  isLoadedData,
  hasLoginBanner,
  study,
  handleRefreshTracking,
}: BiodirectStatusTabProps) =>
  isLoadedData && (
    <div
      className={classNames('biodirect-status-tab animated fadeIn', {
        'has-marketing-banner': auth.hasMarketingBanner() || auth.hasLogoBanner(),
        'has-login-banner': hasLoginBanner,
      })}
    >
      <div className="body-container">
        <div className="biodirect-status-container-box">
          <DrawerContent
            study={study}
            biofluxDirect={study.biofluxDirect}
            isRecipientInformation
            isStudyDetails
            handleRefreshTracking={handleRefreshTracking}
          />
        </div>
        <div className="biodirect-status-container-box">
          <DrawerContent
            study={study}
            biofluxDirect={study.biofluxDirect}
            isStudyDetails
            handleRefreshTracking={handleRefreshTracking}
          />
        </div>
      </div>
    </div>
  );

export default BiodirectStatusTab;
